import Api from './baseService';
import type { SearchResultItem } from '@/models';

async function globalSearch(query: string): Promise<SearchResultItem[]> {
  const params = new URLSearchParams({ query });
  const url = `search?${params.toString()}`;

  const response = await Api.get(url);
  return response.data as SearchResultItem[];
}

export {
  globalSearch,
}
